import { render, staticRenderFns } from "./PriceHome.vue?vue&type=template&id=6200c8b6&"
import script from "./PriceHome.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PriceHome.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6200c8b6')) {
      api.createRecord('6200c8b6', component.options)
    } else {
      api.reload('6200c8b6', component.options)
    }
    module.hot.accept("./PriceHome.vue?vue&type=template&id=6200c8b6&", function () {
      api.rerender('6200c8b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPriceBlockV2/components/PriceHome.vue"
export default component.exports